import React, { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      window.location.replace("/");
      return;
    }

    (async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) throw new Error("session exchange failed");
        const data = await r.json();
        setUser(data);
      } catch (e) {
        console.error(e);
      } finally {
        window.history.replaceState(null, "", "/");
        window.location.replace("/");
      }
    })();
  }, [setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="text-sm text-stone-600 animate-pulse">
        Signing you in…
      </div>
    </div>
  );
}
